<template>
  <div class="admin-settings">
    <header-title title="Envío de Email"></header-title>
    <v-row justify="center">
      <strong
        >La siguiente configuración se utiliza para enviar el electrónico del
        pedido a los clientes</strong
      >
    </v-row>
    <v-container>
      <v-form ref="form" v-model="isValid" class="mx-2" lazy-validation>
        <v-row justify="center" class="mt-5">
          <v-col cols="12" sm="6" class="py-0 py-sm-1">
            <v-text-field
              v-model="input.config_smtp.username"
              outlined
              dense
              type="email"
              required
              placeholder="email@email.com"
              label="Email"
              :rules="validationRules.username"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="input.config_smtp.password"
              outlined
              dense
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              placeholder="******"
              :rules="validationRules.password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              counter
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="input.config_smtp.smtp_host"
              outlined
              dense
              label="SMTP Host"
              placeholder="Ejemplo:smtp.gmail.com"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="input.config_smtp.port"
              outlined
              dense
              label="Puerto"
              placeholder="Ejemplo:465"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-btn
            rounded
            class="submit"
            dark
            justify="center"
            @click="onSaveSetting"
          >
            Guardar
          </v-btn>
        </v-row>
      </v-form>
    </v-container>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
  </div>
</template>
<script>
import { getSettingById, updateSetting } from "@/collections/settings";

const CONFIG_SMTP = {
  config_smtp: {
    username: null,
    password: null,
    smtp_host: null,
    port: null
  }
};
import Loader from "@/components/common/Loader";
import moment from "moment";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";

export default {
  name: "send-email",
  components: { Loader, HeaderTitle },
  data: () => ({
    isValid: false,
    dialogLoader: false,
    input: CONFIG_SMTP,
    showPassword: false,
    validationRules: {
      username: [
        v => !!v || "Correo electronico es requerido",
        v => /.+@.+/.test(v) || "El email debe ser válido"
      ]
    }
  }),
  mounted() {
    this.getData();
  },
  methods: {
    onSaveSetting() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }
      this.saveEmailData({
        ...this.input
      });

      this.showSuccessMessage("Datos guardados");
    },
    async saveEmailData(data) {
      data.config_smtp.username = data.config_smtp
        ? data.config_smtp.username
        : "";
      data.config_smtp.password = data.config_smtp
        ? data.config_smtp.password
        : "";
      data.config_smtp.smtp_host = data.config_smtp
        ? data.config_smtp.smtp_host
        : "";
      data.config_smtp.port = data.config_smtp ? data.config_smtp.port : "";
      data.updated_on = moment().format();

      await updateSetting("settings", data);
    },
    async getData() {
      let self = this;
      this.dialogLoader = true;

      let setting;
      try {
        setting = await getSettingById("settings");

        self.dialogLoader = false;
        self.input = setting;

        if (self.input.config_smtp === undefined) {
          self.input = { ...self.input, ...CONFIG_SMTP };
        }
      } catch (error) {
        this.setlogError(
          "get_setting",
          "Error obteniendo settings",
          error.stack,
          this.$options.name
        );
        self.dialogLoader = false;
      }
    }
  }
};
</script>
